exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".gR5I70HwTXXJaaVW3D9uB{overflow-y:hidden;position:fixed;height:100%;width:100%}", ""]);
// Exports
exports.locals = {
	"roomPickerPane": "gR5I70HwTXXJaaVW3D9uB"
};